<template>
  <header class="account-page-top-bar">
    <button
      v-if="showBack"
      class="account-page-top-bar__back"
      type="button"
      :aria-label="$t('back')"
      @click="$emit('back')"
    >
      <Icon name="arrow-left" />
    </button>
    <h1>{{ title }}</h1>
  </header>
</template>

<script>
import { Icon } from 'vant';

export default {
  name: 'AccountPageTopBar',
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    showBack: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="less" scoped>
.account-page-top-bar {
  position: fixed;
  z-index: 110;
  top: 0;
  left: 50%;
  display: flex;
  width: 100%;
  max-width: 750px;
  height: 96px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: #ffffff;
  transform: translateX(-50%);

  h1 {
    max-width: calc(100% - 176px);
    margin: 0;
    overflow: hidden;
    color: #070d3f;
    font-size: 36px;
    font-weight: 500;
    line-height: 52px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.account-page-top-bar__back {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  width: 80px;
  height: 80px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #070d3f;
  font-size: 40px;
}
</style>
